import { render, staticRenderFns } from "./LaudoEditor.vue?vue&type=template&id=1f956733&"
import script from "./LaudoEditor.vue?vue&type=script&lang=js&"
export * from "./LaudoEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports